function isSwSupported() {
    return 'serviceWorker' in navigator;
}
export function register() {
    if (isSwSupported()) {
        navigator.serviceWorker.register('sw.js');
    }
}

export function unregister() {
    if (isSwSupported()) {
        navigator.serviceWorker.ready.then((registration) => {
            registration.unregister();
        });
    }
}

export function showNotification(title: string, options: NotificationOptions) {
    if (isSwSupported() && Notification.permission === 'granted') {
        navigator.serviceWorker.ready.then((registration) => {
            if (registration) {
                registration.showNotification(title, options);
            }
        });
    }
}
export function closeNotifications(tag: string = '') {
    if (isSwSupported()) {
        navigator.serviceWorker.ready.then((registration) => {
            if (registration?.getNotifications) {
                registration.getNotifications(tag ? { tag } : undefined).then((notifications) => {
                    notifications.forEach((notification) => {
                        notification.close();
                    });
                });
            }
        });
    }
}
